import { useScrollReveal } from '@/hooks/useScrollReveal';

const LegalControl = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      id="how-we-think"
      data-testid="legal-control-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-control-h2">
          Local by default. Approved when it is not.
        </h2>

        <div className="legal-passage mt-8">
          <p className="legal-body" data-testid="legal-control-p1">
            Retrieval and your knowledge environment stay local by default. Some tasks need more capable outside processing, and when that happens the process is gated.
          </p>
          <p className="legal-body mt-6" data-testid="legal-control-p2">
            The context is prepared. Identifiers are reduced or replaced where supported. You see exactly what is proposed to go out. You can edit it. Nothing is sent until you approve it. The result returns to the workspace, and the event is recorded.
          </p>
        </div>

        <div className="legal-limitation mt-10" data-testid="legal-control-limitation">
          <p className="legal-body">
            What we do not claim: identifier scrubbing is partial, and it does not yet remove every identifying narrative fact pattern. The control is that you see and approve outbound content before it is sent, not that confidential information can never leave.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LegalControl;
